import Service from '@ember/service';

export default class BrowserUpdateBannerService extends Service {
  isDismissed = false;
}
